var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 22,
    viewBox: "0 0 52 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2752_19695)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3088 11.701C51.3088 8.06128 49.5458 5.18933 46.1762 5.18933C42.7924 5.18933 40.7451 8.06128 40.7451 11.6725C40.7451 15.952 43.1621 18.1131 46.6312 18.1131C48.3231 18.1131 49.6027 17.7292 50.5694 17.189V14.3454C49.6027 14.8288 48.4937 15.1274 47.0861 15.1274C45.707 15.1274 44.4843 14.644 44.3279 12.9663H51.2803C51.2803 12.7815 51.3088 12.0422 51.3088 11.701ZM44.2853 10.3503C44.2853 8.74372 45.2663 8.0755 46.162 8.0755C47.0293 8.0755 47.9534 8.74372 47.9534 10.3503H44.2853Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2575 5.18933C33.8642 5.18933 32.9685 5.84334 32.4709 6.2983L32.2861 5.41681H29.1582V21.9945L32.7126 21.241L32.7268 17.2174C33.2386 17.587 33.9922 18.1131 35.2433 18.1131C37.7883 18.1131 40.1057 16.0658 40.1057 11.5588C40.0915 7.43571 37.7456 5.18933 35.2575 5.18933ZM34.4045 14.9852C33.5656 14.9852 33.068 14.6867 32.7268 14.317L32.7126 9.04229C33.0822 8.62998 33.5941 8.34563 34.4045 8.34563C35.6983 8.34563 36.594 9.79582 36.594 11.6583C36.594 13.5635 35.7125 14.9852 34.4045 14.9852Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2676 4.35057L27.8362 3.58282V0.696655L24.2676 1.45019V4.35057Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8362 5.43091H24.2676V17.8713H27.8362V5.43091Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.443 6.48312L20.2155 5.43102H17.1445V17.8714H20.6989V9.44037C21.5378 8.34562 22.9595 8.54466 23.4003 8.70106V5.43102C22.9453 5.26041 21.2818 4.94762 20.443 6.48312Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3339 2.34583L9.8648 3.08514L9.85059 14.4734C9.85059 16.5776 11.4287 18.1273 13.5329 18.1273C14.6988 18.1273 15.5518 17.9141 16.021 17.6581V14.772C15.566 14.9568 13.3197 15.6108 13.3197 13.5066V8.45938H16.021V5.43104H13.3197L13.3339 2.34583Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.72302 9.04229C3.72302 8.48781 4.17798 8.27454 4.93151 8.27454C6.01205 8.27454 7.37693 8.60155 8.45747 9.18447V5.84334C7.27741 5.37416 6.11157 5.18933 4.93151 5.18933C2.04535 5.18933 0.125977 6.69639 0.125977 9.2129C0.125977 13.1369 5.52865 12.5114 5.52865 14.2033C5.52865 14.8573 4.95995 15.0705 4.16376 15.0705C2.98371 15.0705 1.47664 14.5871 0.28237 13.9331V17.3169C1.6046 17.8856 2.94105 18.1273 4.16376 18.1273C7.12102 18.1273 9.15413 16.6629 9.15413 14.118C9.13991 9.88113 3.72302 10.6347 3.72302 9.04229Z",
    fill: "#635BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2752_19695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.1861,
    height: 21.3036,
    fill: "white",
    transform: "translate(0.125977 0.696411)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.f1a421bd3c09bc033d7aec07d33a8dbf.svg";
export { ForwardRef as ReactComponent };